import apiServices from '@/shared/services/api/axios'
import { ITypeIdDetail } from '@/modules/advisor/modules/announcement/shared/contants'

const AnnounceGuestService = {
    apiGetListAnnouncements(payload: any) {
        let url = '/announcements'
        if (payload) {
            let index = 0
            for (const key in payload) {
                if (payload[key]) {
                    if (!index) {
                        url += `?${key}=${payload[key]}`
                    }
                    if (index) {
                        url += `&${key}=${payload[key]}`
                    }
                    index++
                }
            }
        }
        return apiServices.get(url)
    },
    apiGetDetailAnnouncement(id: ITypeIdDetail) {
        return apiServices.get(`/announcements/${id}`)
    }
}
export default AnnounceGuestService
